<body>
    <div>
        <div *ngIf="dataLoaded">
            <table class="table2">
                <thead>
                    <th class="centro-align">
                        <!-- <i-feather name="plus-circle" (click)="addViagem('')"></i-feather> -->
                    </th>
                    <th class="corlinha">
                        Container Exportação
                    </th>
                </thead>
            </table>

            <div class="table2">
                <table>
                    <thead>
                        <tr>
                            <th class="auto-width">
                                Remessa
                            </th>
                            <th class="auto-width">
                                Placa
                            </th>
                            <th class="auto-width">
                                Localização Atual do Veículo
                            </th>
                            <th class="auto-width">
                                Posição atual do Veículo
                            </th>
                            <th class="auto-width">
                                Rastreio
                            </th>
                            <th class="auto-width">
                                Container
                            </th>
                            <th class="auto-width">
                                Transportador
                            </th>
                            <th class="auto-width">
                                Janela
                            </th>
                            <th class="auto-width">
                                Linner
                            </th>
                            <th>
                                Booking
                            </th>
                            <th>
                                Observações
                            </th>  
                            <th>
                                Danificado
                            </th>                      
                            <th>
                                Editar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of items; let i = index">
                            <tr>
                                <!-- <td [attr.contenteditable]="editMode[i] ? true : null">{{ item["Transport Type"] }}</td> -->
                                <!-- <td (click)="toggleEditMode(i)">{{ item["Plate"] }}</td> -->
                                <td>{{ item.remessa }}</td>
                                <td>{{ item.Plate}}</td>
                                <td>{{ item.localizacao}}</td>
                                <td>{{ item.position}}</td>
                                <td *ngIf="item['Conexao'] === true" ><i-feather name="zap"
                                    class="blinking-icon"></i-feather></td>
                                <td *ngIf="item['Conexao'] !== true" ><i-feather name="zap-off"
                                    class="vermelho-icon"></i-feather></td>
                                <td>{{ item.idContainer}}</td>
                                <td>{{ item.transportador}}</td>
                                <td>{{ item.Janela | date : 'dd/MM/yyyy HH:mm' : '+00:00' }}</td>
                                <td>{{ item.linner}}</td>
                                <td>{{ item.booking}}</td>
                                <td>{{ item.observacoes}}</td>                               
                                <td *ngIf="item.danificado">
                                    <input type="checkbox" [checked]="item.danificado">
                                  </td>
                                  <td *ngIf="!item.danificado">
                                    <input type="checkbox" [disabled]="true">
                                  </td>
                                <td class="same-line-container">
                                    <i-feather name="edit" (click)="editDialog(item)"
                                        class="button-spacing"></i-feather>
                                    <i-feather name="check-square" (click)="completaViagem(item)"
                                        class="button-spacing"></i-feather>
                                    <i-feather name="delete" (click)="deleteItem(item.ID)"
                                        class="button-spacing"></i-feather>
                                </td>
                            </tr>
                            <div *ngIf="informationMode[i]">
                                <table class="centered-table">
                                    <tr>
                                        <td><label>Última Atualização</label></td>
                                        <td><label>Último Sinal do Veículo</label></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="text" [(ngModel)]="item['data_atualizacao']">
                                        </td>
                                        <td>
                                            <input type="text" [(ngModel)]="item['DataBordo']">
                                        </td>
                                    </tr>

                                </table>
                                <table class="centered-table2">
                                    <tr>
                                        <button (click)="informationMode[i] = false">Ok</button>
                                    </tr>
                                </table>
                            </div>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h3 class="modal-title">Ajuste de Programação</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000 edicao">
                <tr>
                    <td class="tdLabel">
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="Transportadora" [(ngModel)]="item.Transportadora" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Container</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="idContainer" [(ngModel)]="item.idContainer" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td class="tdLabel">
                        <label class="modal-label">Remessa</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="remessa" [(ngModel)]="item.remessa" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Linner</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="linner" [(ngModel)]="item.linner" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Booking</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="booking" [(ngModel)]="item.booking" class="modal-input1">
                    </td>
                </tr>
                <!-- <tr>
                    <td class="tdLabel">
                        <label class="modal-label" >Terminal Origem
                        </label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="terminalOrigem" [(ngModel)]="item.terminalOrigem"
                            class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label" >Transferência
                        </label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="DTAData" [(ngModel)]="item.DTAData"
                            class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label" >Modal
                        </label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="modal" [(ngModel)]="item.modal"
                            class="modal-input1">
                    </td>
                </tr> -->
           
                <tr>
                    <td class="tdLabel">
                        <label class="modal-label" >Observações</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" id="observacoes" [(ngModel)]="item.observacoes" name="terminalAtual"
                            class="button-spacing">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Danificado</label>
                    </td>
                    <td class="checkBox">
                        <input  type="checkbox" name="danificado" [(ngModel)]="item.danificado" class="modal-input1">
                    </td>
               
                    <!-- <td class="tdLabel">
                        <label class="modal-label">Item Crítico</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="itemCritico" [(ngModel)]="item.itemCritico" class="modal-input1">
                    </td> -->
                    <td class="tdLabel">
                        <label class="modal-label">Janela</label>
                    </td>
                    <td class="tdInput">
                        <!-- <input type="string" name="Janela" [(ngModel)]="item.Janela" class="modal-input1"> -->
                        <input type="date" name="dataJanela" [(ngModel)]="item.dataJanela" class="modal-input1">
                        <input type="time" name="horaJanela" [(ngModel)]="item.horaJanela" class="modal-input1">
                    </td>
                    <!-- <td>
                        <label class="modal-label">Data falta</label>
                    </td>

                    <td>
                        <input type="string" name="dataFalta" [(ngModel)]="item.dataFalta" class="modal-input1">
                    </td>            -->
                </tr>
                <!-- </table>
            <table class="table2000"> -->
                <tr>
                    <td class="tdBotao">
                        <button class="botao" type="button" (click)="salvar(item)">Save</button>
                        <!-- <button class="botao" type="button" (click)="onStartNodeServer()">server</button> -->
                        <!-- <button class="botao" type="button">Save</button> -->
                    </td>
                    <td class="tdBotao">
                        <!-- <button class="botao" type="button" (click)="salvar2()">Save</button> -->
                        <button class="botao" type="button" (click)="cancel()">Cancel</button>
                    </td>
                </tr>
            </table>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>